import { InfoTooltip } from "./InfoTooltip";

interface SummaryTileProps {
  title: string;
  value: string;
  tooltipText: string;
}

export function SummaryTile({ title, value, tooltipText }: SummaryTileProps) {
  return (
    <article className="info-box">
      <header className="box-header">
        <div className="box-title">
          <span>{title}</span>
          <InfoTooltip text={tooltipText} />
        </div>
      </header>
      <p className="box-number">{value}</p>
    </article>
  );
}
